import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { ChevronRight } from 'lucide-react';
import { FunnelStep } from '../../types';
import { formatNumber } from '../../constants/nginx-sites';

interface ConversionFunnelProps {
  funnelData: FunnelStep[];
  color: string;
}

export function ConversionFunnel({ funnelData, color }: ConversionFunnelProps) {
  if (!funnelData || funnelData.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Funil de Conversão</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col md:flex-row items-center gap-2">
          {funnelData.map((step, index) => (
            <div key={step.name} className="flex items-center gap-2 flex-1 w-full md:w-auto">
              <div className="flex-1 min-w-0">
                <div
                  className="px-4 py-3 rounded-lg text-white font-medium text-sm text-center"
                  style={{ backgroundColor: color }}
                >
                  <div className="font-semibold">{step.name}</div>
                  <div className="text-xs mt-1">
                    {formatNumber(step.count)} ({(step.percentage ?? 0).toFixed(1)}%)
                  </div>
                </div>
              </div>
              {index < funnelData.length - 1 && (
                <ChevronRight className="h-5 w-5 text-muted-foreground shrink-0 hidden md:block" />
              )}
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
